import { strapi } from '@strapi/client'

let client

export function useStrapi() {
  client = strapi({
    baseURL: useRuntimeConfig().public.strapiUrl,
    auth: useRuntimeConfig().public.strapiApiToken
  })

  return client
}
